/*
 * @Author: cryi.liu
 * @Date: 2020-05-09 15:36:36
 * @LastEditTime: 2020-09-14 16:29:18
 * @Description: write you description
 */
/* eslint-disable class-methods-use-this */
import axios from '../../plugins/axios';
import API from '../api';
import { createObjectURL, getDateTime } from '../../utils';
import store from '../../store';

const jsonStringFormat = (data = {}) => JSON.stringify(data);
const formDataFormat = (data = {}) => {
  const postData = new FormData();

  Object.keys(data).forEach((key) => {
    postData.append(key, data[key]);
  });

  return postData;
};

class BaseService {
  constructor() {
    this.API = API;
  }

  /**
   * @author cryi.liu
   * @param {string} url
   * @param {object} params
   * @desc Content-Type: application/json；method: post；payload: query
   * @func 数据请求
   */
  async jsonPostOfQuery(url, params = {}) {
    let result = {};

    try {
      result = (await axios(url, {
        method: 'post',

        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },

        transformRequest: [jsonStringFormat],

        params,
      })).data;

      result.success = true;
    } catch (error) {
      result = {
        success: false,
        message: error.toString(),
        returnCode: error.status,
      };
    }

    return result;
  }

  /**
   * @author cryi.liu
   * @param {string} url
   * @param {object} data
   * @desc Content-Type: application/json；method: post；payload: body
   * @func 数据请求
   */
  async jsonPostOfBody(url, data = {}) {
    let result = {};

    try {
      result = (await axios(url, {
        method: 'post',

        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },

        transformRequest: [jsonStringFormat],

        data,
      })).data;

      result.success = true;
    } catch (error) {
      result = {
        success: false,
        message: error.toString(),
        returnCode: error.status,
      };
    }

    return result;
  }

  /**
   * @author cryi.liu
   * @param {string} url
   * @param {object} data
   * @desc Content-Type: application/json；method: put；payload: body
   * @func 数据请求
   */
  async jsonPutOfBody(url, data = {}) {
    let result = {};

    try {
      result = (await axios(url, {
        method: 'put',

        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },

        transformRequest: [jsonStringFormat],

        data,
      })).data;

      result.success = true;
    } catch (error) {
      result = {
        success: false,
        message: error.toString(),
        returnCode: error.status,
      };
    }

    return result;
  }

  /**
   * @author cryi.liu
   * @param {string} url
   * @param {object} params
   * @desc Content-Type: application/x-www-form-urlencoded；method: post；payload: query
   * @func 数据请求
   */
  async formPostOfQuery(url, params = {}) {
    let result = {};

    try {
      result = (await axios(url, {
        method: 'post',

        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },

        params,
      })).data;

      result.success = true;
    } catch (error) {
      result = {
        success: false,
        message: error.toString(),
        returnCode: error.status,
      };
    }

    return result;
  }

  /**
   * @author cryi.liu
   * @param {string} url
   * @param {object} data
   * @desc Content-Type: application/x-www-form-urlencoded；method: post；payload: body
   * @func 数据请求
   */
  async formPostOfBody(url, data = {}) {
    let result = {};
    try {
      result = (await axios(url, {
        method: 'post',

        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },

        data,
      })).data;

      result.success = true;
    } catch (error) {
      result = {
        success: false,
        message: error.toString(),
        returnCode: error.status,
      };
    }

    return result;
  }

  /**
   * @author cryi.liu
   * @param {string} url
   * @param {object} params
   * @desc Content-Type: application/json；method: get；payload: query
   * @func 数据请求
   */
  async jsonGetOfQuery(url, params = {}) {
    let result = {};

    try {
      result = (await axios(url, {
        method: 'get',

        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },

        transformRequest: [jsonStringFormat],

        params,
      })).data;

      result.success = true;
    } catch (error) {
      result = {
        success: false,
        message: error.toString(),
        returnCode: error.status,
      };
    }

    return result;
  }

  /**
   * @author cryi.liu
   * @param {string} url
   * @param {object} data
   * @desc Content-Type: application/json；method: get；payload: body
   * @func 数据请求
   */
  async jsonGetOfBody(url, data = {}) {
    let result = {};

    try {
      result = (await axios(url, {
        method: 'get',

        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },

        transformRequest: [jsonStringFormat],

        data,
      })).data;

      result.success = true;
    } catch (error) {
      result = {
        success: false,
        message: error.toString(),
        returnCode: error.status,
      };
    }

    return result;
  }

  /**
   * @author cryi.liu
   * @param {string} url
   * @param {object} params
   * @desc Content-Type: application/x-www-form-urlencoded；method: get；payload: query
   * @func 数据请求
   */
  async formGetOfQuery(url, params = {}) {
    let result = {};

    try {
      result = (await axios(url, {
        method: 'get',

        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },

        params,
      })).data;

      result.success = true;
    } catch (error) {
      result = {
        success: false,
        message: error.toString(),
        returnCode: error.status,
      };
    }

    return result;
  }

  /**
   * @author cryi.liu
   * @param {string} url
   * @param {object} data
   * @desc Content-Type: application/x-www-form-urlencoded；method: get；payload: body
   * @func 数据请求
   */
  async formGetOfBody(url, data = {}) {
    let result = {};

    try {
      result = (await axios(url, {
        method: 'get',

        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },

        data,
      })).data;

      result.success = true;
    } catch (error) {
      result = {
        success: false,
        message: error.toString(),
        returnCode: error.status,
      };
    }

    return result;
  }

  /**
   * @param {*} url
   * @param {*} params
   * @desc Content-Type: application/x-www-form-urlencoded；method: put；payload: query
   * @func 数据请求
   */
  async formPutOfQuery(url, params) {
    let result = {};

    try {
      result = (await axios(url, {
        method: 'put',

        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },

        params,
      })).data;

      result.success = true;
    } catch (error) {
      result = {
        success: false,
        message: error.toString(),
        returnCode: error.status,
      };
    }

    return result;
  }

  /**
   * @param {*} url
   * @param {*} params
   * @desc Content-Type: application/x-www-form-urlencoded；method: delete；payload: query
   * @func 数据请求
   */
  async formDeleteOfQuery(url, params) {
    let result = {};

    try {
      result = (await axios(url, {
        method: 'delete',

        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },

        params,
      })).data;

      result.success = true;
    } catch (error) {
      result = {
        success: false,
        message: error.toString(),
        returnCode: error.status,
      };
    }

    return result;
  }

  /**
   * @author cryi.liu
   * @param {string} url
   * @param {object} data
   * @desc Content-Type: multipart/form-data；method: post；payload: body
   * @func 数据请求
   */
  async multiPostOfBody(url, data = {}) {
    let result = {};

    try {
      result = (await axios(url, {
        method: 'post',

        headers: {
          'Content-Type': 'multipart/form-data; charset=utf-8',
        },

        transformRequest: [formDataFormat],

        data,
      })).data;

      result.success = true;
    } catch (error) {
      result = {
        success: false,
        message: error.toString(),
        returnCode: error.status,
      };
    }

    return result;
  }

  /**
   * 下载excel表格文件
   */
  downloadExcelFileOfQuery(url, method, filename, extension = '.xlsx') {
    return new Promise(async (resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.open(method, url);
      xhr.setRequestHeader('psstoken', store.getters['authStore/token']);
      xhr.responseType = 'blob';
      xhr.onload = function xhrOnload() {
        if (this.status === 200) {
          const blob = new Blob([this.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            const a = document.createElement('a');
            const blobUrl = createObjectURL(blob);
            a.href = blobUrl;
            a.download = filename + getDateTime() + extension;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(blobUrl);
          }
        }

        resolve({ result: true, code: '200', message: '成功' });
      };

      xhr.onerror = function xhrOnerror() {
        resolve({ result: true, code: '500', message: '失败' });
      };

      xhr.send();
    });
  }
}

export default BaseService;
